import io from 'socket.io-client';
// const sockets = io.connect('http://localhost:3000', { transports: ['websocket'] });
const sockets = io.connect('https://upsc.trando.in', { transports: ['websocket'] });
// console.log(sockets);
export default sockets